// ENVIRONMENT VARIABLES
const IP_URL = process.env.REACT_APP_IP_URL
const PORT = process.env.REACT_APP_PORT
const PROTOCOL = process.env.REACT_APP_PROTOCOL


async function postRequestAPI(endpoint, body) {
  try {
    console.log('FETCH API')
    console.log('state from request ', body)
    const response = await fetch(`${PROTOCOL}://${IP_URL}:${PORT}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body), 
    })
    const data = await response.json()
    // console.log('response from backend in postRequest function', data)
    if (data.status == 200) {     
      return data
    } else {
      return data
    }
  } catch (error) {
    console.log(`error fetching data with endpoint: ${endpoint}`)
    return {
      mesagge: error.mesagge,
      status: 500,
      endpoint: endpoint
    }
  }
}

export function acceptMobileState(state) {
  const response = postRequestAPI('accept_new_tum', state)
  return response
}

export function declineMobileState(state) {
  const response = postRequestAPI('decline_new_tum', state)
  return response
}